import { render } from "./AlertComponent.vue?vue&type=template&id=4fe2517b&scoped=true&ts=true"
import script from "./AlertComponent.vue?vue&type=script&lang=ts"
export * from "./AlertComponent.vue?vue&type=script&lang=ts"

import "./AlertComponent.vue?vue&type=style&index=0&id=4fe2517b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fe2517b"]])

export default __exports__